const DEFAULT_WORDPRESS_SITE_BASE = "https://fluxmed.cloud";

/**
 * Base do site WordPress (sem sufixo REST WooCommerce).
 * `siteOrigin` no registry pode incluir `/wp-json/wc/v3` — este helper remove para wp-admin/wp-login.
 */
export function resolveWordPressSiteBase(siteOrigin?: string): string {
  const raw = (siteOrigin?.trim() || DEFAULT_WORDPRESS_SITE_BASE).replace(/\/$/, "");
  const base = raw.replace(/\/wp-json\/wc\/v3\/?$/i, "");
  return base || DEFAULT_WORDPRESS_SITE_BASE;
}
